import type { FC } from 'react';
import { z } from 'zod';

import { FullPageContent } from '@/components/layout/full-page-content';
import { Dashboard } from '@/components/looker/dashboard';
import { codec, useQueryParams } from '@/hooks/router/use-query-params';

export const WarrantyPageLegacy: FC = () => {
  const [{ site_id, top_id, unit_id }] = useQueryParams({
    site_id: {
      key: 'site_id',
      schema: z.string().optional(),
      codec: codec.string,
    },
    top_id: {
      key: 'top_id',
      schema: z.string().optional(),
      codec: codec.string,
    },
    unit_id: {
      key: 'unit_id',
      schema: z.string().optional(),
      codec: codec.string,
    },
  });

  return (
    <FullPageContent>
      <Dashboard
        id="warranty"
        filters={{ group_id: site_id, top_id, unit_id }}
      />
    </FullPageContent>
  );
};
